import React from "react";
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, Paper
} from '@material-ui/core';
import moment from 'moment';


export default class ComponentToPrint extends React.Component {

  calculateAverage(month1, month2, month3) {
    const validMonths = [month1, month2, month3].filter(
      val => val !== 0 && val !== null && val !== undefined
    );
    if (validMonths.length === 0) return 0;
    return (month1 + month2 + month3) / validMonths.length;
  }


  render() {
    const notSupplyDebtList = this.props.notSupplyDebtList;
    const searchData = this.props.searchData;
    const totalAmount = this.props.totalAmount;
    const totalLoanBalance = this.props.totalLoanBalance;
    const totalBalance = this.props.totalBalance;


    return (
      <div>
        <h3><center><u>Not Supply Debt List Report 2</u></center></h3>
        <div>&nbsp;</div>
        <h4><center>Group - {searchData.groupName}</center></h4>
        <h4><center>Factory - {searchData.factoryName}</center></h4>
        <h4><center>Route - {searchData.routeName == undefined ? 'All Routes' : searchData.routeName}</center></h4>
        <h4><center>Month & Year - {moment(searchData.date).format('YYYY-MM')}</center></h4>
        <div>&nbsp;</div>
        <div>
          <Box display="flex" justifyContent="flex-end" p={2}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center" style={{ border: "1px solid black", height: "10px", padding: "4px" }}>Registration Number</TableCell>
                    <TableCell align="center" style={{ border: "1px solid black", height: "10px", padding: "4px" }}>Customer Name</TableCell>
                    <TableCell align="center" style={{ border: "1px solid black", height: "10px", padding: "4px" }}>Last 3 Months Crop Avg (Kg)</TableCell>
                    <TableCell align="center" style={{ border: "1px solid black", height: "10px", padding: "4px" }}>Todate Crop (Kg)</TableCell>
                    <TableCell align="center" style={{ border: "1px solid black", height: "10px", padding: "4px" }}>Debt Amount (Rs)</TableCell>
                    <TableCell align="center" style={{ border: "1px solid black", height: "10px", padding: "4px" }}>Loan Balance (Rs)</TableCell>
                    <TableCell align="center" style={{ border: "1px solid black", height: "10px", padding: "4px" }}>Last Supply Month</TableCell>
                    <TableCell align="center" style={{ border: "1px solid black", height: "10px", padding: "4px" }}>Balance (Rs)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {notSupplyDebtList.map((group, index) => (
                    <React.Fragment key={index}>
                      <TableRow>
                        <TableCell colSpan={8} align="center" style={{ fontWeight: "bold", border: "1px solid black", height: "10px", padding: "2px" }}>
                          {group.routeName}
                        </TableCell>
                      </TableRow>
                      {group.records.map((rec, idx) => (
                        <TableRow key={`${index}-${idx}`}>
                          <TableCell style={{ border: "1px solid black", height: "5px", padding: "2px" }}>{rec.registrationNumber}</TableCell>
                          <TableCell style={{ border: "1px solid black", height: "5px", padding: "2px" }}>{rec.name}</TableCell>
                          <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid black", padding: "2px" }}>
                            {this.calculateAverage(rec.month1, rec.month2, rec.month3).toFixed(2)}
                          </TableCell>
                          <TableCell align={'right'} style={{ border: "1px solid black", height: "5px", padding: "2px" }}>{rec.todateCrop.toFixed(2)}</TableCell>
                          <TableCell align={'right'} style={{ border: "1px solid black", height: "5px", padding: "2px" }}>{rec.amount.toFixed(2)}</TableCell>
                          <TableCell align={'right'} style={{ border: "1px solid black", height: "5px", padding: "2px" }}>{rec.loanBalance.toFixed(2)}</TableCell>
                          <TableCell style={{ border: "1px solid black", height: "5px", padding: "2px" }}>{rec.lastSupplyMonth}</TableCell>
                          <TableCell align="right" style={{ border: "1px solid black", height: "5px", padding: "2px" }}>{rec.balance.toFixed(2)}</TableCell>
                        </TableRow>
                      ))}
                      <TableRow>
                        <TableCell colSpan={4} align="left" style={{ border: "1px solid black", fontWeight: "bold", height: "10px", padding: "2px" }}><b>Route Total: ({group.records.length})</b></TableCell>
                        <TableCell align="right" style={{ border: "1px solid black", fontWeight: "bold", height: "10px", padding: "2px" }}><b>{group.totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></TableCell>
                        <TableCell align="right" style={{ border: "1px solid black", fontWeight: "bold", height: "10px", padding: "2px" }}><b>{group.totalLoanBalance.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></TableCell>
                        <TableCell align="right" style={{ border: "1px solid black", fontWeight: "bold", height: "10px", padding: "2px" }}><b></b></TableCell>
                        <TableCell align="right" style={{ border: "1px solid black", fontWeight: "bold", height: "10px", padding: "2px" }}><b>{group.totalBalance.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                  {searchData.routeName == undefined ?
                    <TableRow>
                      <TableCell colSpan={4} align="left" style={{ border: "1px solid black", height: "10px", padding: "2px" }}><b>Grand Total:</b></TableCell>
                      <TableCell align="right" style={{ border: "1px solid black", height: "10px", padding: "2px" }}><b>{totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></TableCell>
                      <TableCell align="right" style={{ border: "1px solid black", height: "10px", padding: "2px" }}><b>{totalLoanBalance.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></TableCell>
                      <TableCell align="right" style={{ border: "1px solid black", height: "10px", padding: "2px" }}><b></b></TableCell>
                      <TableCell align="right" style={{ border: "1px solid black", height: "10px", padding: "2px" }}><b>{totalBalance.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></TableCell>
                    </TableRow>
                    : null}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </div>
    );
  }
}
